import React from "react";
import UnlistedHoldingsTable from "../../components/HoldingsTable/UnlistedHoldingsTable";
import HoldingsErrorDialog from "../../components/HoldingsTable/HoldingsErrorDialog";
import AppLoader from "../../components/AppLoader/AppLoader";
import { useUserHoldingsFetch } from "./useUserHoldingsFetch";

interface Unlisted {
  requestId: number;
  id: number;
  noteficationId: number;
  holdingName: string;
  category: string;
  investedAmount: number;
  rateDate: string;
  rate: number;
  realisedPnL: number;
  transactions: [];
  days: number;
  unrealisedPnL: number;
  absolutePnL: number;
  type: string;
  symbol: string;
  units: number;
  amount: number;
  purchasePrice: number;
  currentAmount: number;
  redeemUnits: number;
  transactionDate: string;
  currentPrice: number;
  gainLoss: number;
  gainLossPerc: string;
  xirr: string;
}

const UnlistedHoldings: React.FC = () => {
  const {
    loader,
    errorMessage,
    setErrorMessage,
    data: Unlisted,
    pageSize,
    totalPages,
    currentPage,
    handlePageChange,
    handlePageSizeChange,
    fetchHoldings,
  } = useUserHoldingsFetch<Unlisted>(
    "PRIVATE_STOCK",
    "Failed to load unlisted equity holdings."
  );

  return (
    <>
      <AppLoader loading={loader} />
      <UnlistedHoldingsTable
        data={Unlisted}
        totalPages={totalPages}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        fetchData={fetchHoldings}
      />
      <HoldingsErrorDialog
        open={Boolean(errorMessage)}
        message={errorMessage}
        title="Unable to load unlisted equity holdings"
        onClose={() => setErrorMessage(null)}
      />
    </>
  );
};

export default UnlistedHoldings;
